export * from "/__w/wiggot-web/wiggot-web/packages/web-components/components/modals-services-provider/index.ts"